const dateTimeFormat = new Intl.DateTimeFormat(navigator.language, { hour: "numeric" }).format(new Date(2020, 0, 1, 13));
const use12HourClock = dateTimeFormat.includes("PM") || dateTimeFormat.includes("AM");

const DATEFORMAT = "MMMM dd, yyyy";
let DATETIMEFORMAT = "MMMM dd, yyyy HH:mm";
let TIMEFORMAT = "HH:mm";
let EVENTDATETIMEFORMAT = "MMMM dd, HH:mm";

if (use12HourClock) {
	DATETIMEFORMAT = "MMMM dd, yyyy HH:mm a";
	TIMEFORMAT = "HH:mm a";
	EVENTDATETIMEFORMAT = "MMMM dd, HH:mm a";
}

export { DATETIMEFORMAT, DATEFORMAT, TIMEFORMAT, EVENTDATETIMEFORMAT, use12HourClock };